const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');

const ProductForm = require('app/product/Form');

class InfoTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'product': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.product = this.settings.product;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    onDOMReady(){
        this.productForm.onDOMReady();
    }

    buildTab(){
        this.$container
        .html('')
        .append(this.buildInfosForm());

        this.onDOMReady();
    }

    buildInfosForm(){
        var self = this;
        this.productForm = new ProductForm({
            'product': this.product,
            'success': function(){
                self.productForm.refresh();
            }
        });

        return this.productForm.getForm();
    }

}

module.exports = InfoTab;

